<template>
  <div class="ncp-overlay" @click.self="$emit('close')">
    <div class="card ncp-card" role="dialog" aria-label="Nova campanha">
      <div class="card-head">
        <h3>Nova campanha</h3>
        <button class="ncp-x" aria-label="Fechar" @click="$emit('close')">
          ✕
        </button>
      </div>

      <div class="field">
        <label class="label">Nome da campanha</label>
        <input
          v-model="name"
          class="input"
          placeholder="Ex.: Reativação de agosto"
        />
      </div>

      <div class="field">
        <label class="label">Público</label>
        <select v-model.number="cutoff" class="select">
          <option v-for="c in cutoffs" :key="c" :value="c">
            Sem retorno há {{ c }}+ dias{{ countLabel(c) }}
          </option>
        </select>
      </div>

      <div class="field">
        <label class="label">
          Mensagem
          <span class="ncp-opt">(opcional — enviada por WhatsApp + SMS)</span>
        </label>
        <textarea
          v-model="message"
          class="textarea"
          rows="3"
          placeholder="Sentimos sua falta! Que tal agendar um retorno?"
        />
      </div>

      <div class="ncp-actions">
        <button class="btn btn--outline btn--sm" @click="$emit('close')">
          Cancelar
        </button>
        <button
          class="btn btn--primary btn--sm"
          :disabled="submitting"
          @click="submit"
        >
          {{ submitting ? "Criando…" : "Criar campanha" }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Criação de campanha de reativação (substitui o window.prompt): nome,
// público por corte de sem-retorno (30/60/90 dias, com contagem real) e
// mensagem opcional (vazia → default do backend). O público é resolvido
// aqui em IDs explícitos via /clinica/no-return.
import {
  ClinicCampaigns as CampaignsService,
  ClinicFollowup
} from "@/services/clinica";

export default {
  name: "ClinicNewCampaign",
  data() {
    return {
      name: "",
      message: "",
      cutoff: 30,
      cutoffs: [30, 60, 90],
      counts: {},
      submitting: false
    };
  },
  created() {
    this.loadCounts();
  },
  methods: {
    async loadCounts() {
      try {
        const { data } = await ClinicFollowup.noReturn({ cutoff: 30 });
        this.counts = data.counts || {};
      } catch (e) {
        this.counts = {};
      }
    },
    countLabel(c) {
      const n = this.counts[c];
      return n == null ? "" : ` (${n} pacientes)`;
    },
    async submit() {
      const name = this.name.trim();
      if (!name) {
        this.$toast.error("Informe um nome para a campanha");
        return;
      }
      this.submitting = true;
      try {
        // resolve o público do corte escolhido em IDs explícitos
        const { data: pub } = await ClinicFollowup.noReturn({
          cutoff: this.cutoff
        });
        const audience = (pub.items || []).map(p => p.id);
        const { data } = await CampaignsService.create({
          name,
          message: this.message.trim() || undefined,
          audience
        });
        this.$toast.success("Campanha criada");
        this.$emit("created", data);
      } catch (e) {
        this.$toast.error("Não foi possível criar a campanha");
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.ncp-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  z-index: 80;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-5);
}
.ncp-card {
  width: 100%;
  max-width: 440px;
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}
.ncp-x {
  border: none;
  background: none;
  color: var(--color-gray-400);
  font-size: var(--font-size-md);
  cursor: pointer;
  &:hover {
    color: var(--color-gray-700);
  }
}
.ncp-opt {
  color: var(--color-gray-400);
  font-weight: var(--fw-regular);
}
.ncp-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
}
</style>
